/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Tooltip } from '@ui/components';

const triggerStyle: React.CSSProperties = {
    borderBottom: '1px dashed currentColor',
    cursor: 'help',
};

export const DefaultTooltipExample = () => (
    <Tooltip title="Media value details">
        <span style={triggerStyle}>Hover for details</span>
    </Tooltip>
);

export const PlacementsTooltipExample = () => (
    <span
        style={{
            alignItems: 'center',
            display: 'inline-flex',
            flexDirection: 'column',
            gap: 32,
            padding: '24px 0',
        }}
    >
        {(['top', 'right', 'bottom', 'left'] as const).map(placement => (
            <Tooltip
                key={placement}
                placement={placement}
                title={`Placement: ${placement}`}
            >
                <span style={triggerStyle}>{placement}</span>
            </Tooltip>
        ))}
    </span>
);

export const DisabledTriggerTooltipExample = () => (
    <Tooltip title="This action is unavailable for the current report">
        <span style={{ cursor: 'not-allowed', display: 'inline-block' }}>
            <button disabled type="button">
                Disabled action
            </button>
        </span>
    </Tooltip>
);

export const LongContentTooltipExample = () => (
    <Tooltip title="Tooltips can carry a longer explanatory sentence, wrapping onto multiple lines while staying anchored to the trigger element.">
        <span style={triggerStyle}>Long content</span>
    </Tooltip>
);
